function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ApprovalBill',
  formCreateParser: {
    loadChildren: false,
    renderChildren: function renderChildren(ctx) {
      return [];
    }
  },
  props: {
    formCreateInject: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      rule: this.formCreateInject.rule.children,
      len: 0,
      cacheRule: {},
      cacheValue: {},
      type: undefined
    };
  },
  watch: {
    value: function value(n) {
      var _this = this;
      n = n || [];
      var keys = Object.keys(this.cacheRule);
      var total = keys.length;
      var len = total - n.length;
      if (len < 0) {
        for (var i = len; i < 0; i++) {
          this.addRule(n.length + i);
        }
        for (var _i = 0; _i < total; _i++) {
          this.setValue(keys[_i], n[_i]);
        }
      } else {
        if (len > 0) {
          for (var _i2 = 0; _i2 < len; _i2++) {
            this.removeRule(keys[total - _i2 - 1]);
          }
          this.subForm();
        }
        n.forEach(function (val, i) {
          _this.setValue(keys[i], n[i]);
        });
      }
    }
  },
  created: function created() {
    this.type = this.formCreateInject.form.$form();
    if (!this.value.length) this.expandRule(1);
    for (var i = 0; i < this.value.length; i++) {
      this.addRule(i);
    }
  },
  methods: {
    cache: function cache(k, val) {
      this.cacheValue[k] = JSON.stringify(val);
    },
    input: function input(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },
    formData: function formData(key, _formData) {
      var _this2 = this;
      var cacheRule = this.cacheRule;
      var keys = Object.keys(cacheRule);
      if (keys.filter(function (k) {
        return cacheRule[k].$f;
      }).length !== keys.length) {
        return;
      }
      var value = keys.map(function (k) {
        var data = key === k ? _formData : _objectSpread({}, _this2.cacheRule[k].$f.form);
        _this2.cache(k, data);
        return data;
      });
      this.input(value);
    },
    setValue: function setValue(key, value) {
      if (this.cacheValue[key] === JSON.stringify(value)) {
        return;
      }
      this.cache(key, value);
      this.cacheRule[key].$f && this.cacheRule[key].$f.coverValue(value || {});
    },
    addRule: function addRule(i, emit) {
      var _this3 = this;
      var rule = this.formCreateInject.form.copyRules(this.rule);
      var options = this.options ? _objectSpread({}, this.options) : {
        submitBtn: false,
        resetBtn: false
      };
      options.formData = this.value[i];
      this.$set(this.cacheRule, ++this.len, {
        rule: rule,
        options: options
      });
      if (emit) {
        this.$nextTick(function () {
          return _this3.$emit('add', rule, Object.keys(_this3.cacheRule).length - 1);
        });
      }
    },
    add$f: function add$f(key, $f) {
      this.cacheRule[key].$f = $f;
      this.subForm();
    },
    subForm: function subForm() {
      var _this4 = this;
      this.formCreateInject.subForm(Object.keys(this.cacheRule).map(function (k) {
        return _this4.cacheRule[k].$f;
      }));
    },
    removeRule: function removeRule(key, emit) {
      var _this5 = this;
      var index = Object.keys(this.cacheRule).indexOf(key);
      this.$delete(this.cacheRule, key);
      this.$delete(this.cacheValue, key);
      if (emit) {
        this.$nextTick(function () {
          return _this5.$emit('remove', index);
        });
      }
    },
    add: function add(i) {
      this.addRule(i, true);
    },
    del: function del(key) {
      var i = Object.keys(this.cacheRule).indexOf(key);
      this.removeRule(key, true);
      this.subForm();
      this.value.splice(i, 1);
      this.input(this.value);
    },
    expandRule: function expandRule(n) {
      for (var i = 0; i < n; i++) {
        this.value.push(this.field ? null : {});
      }
    }
  }
};